import { render, staticRenderFns } from "./AdCardPay.vue?vue&type=template&id=5797dd68&scoped=true"
import script from "./AdCardPay.vue?vue&type=script&lang=js"
export * from "./AdCardPay.vue?vue&type=script&lang=js"
import style0 from "./AdCardPay.vue?vue&type=style&index=0&id=5797dd68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5797dd68",
  null
  
)

export default component.exports